module.exports = __webpack_public_path__ + "static/media/21-api.bf79d3d6.svg";